import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchPageBySlug } from '../utils/pageApi';
import { StaticPage } from '../types';

const StaticPageView: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [page, setPage] = useState<StaticPage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPage = async () => {
      if (slug) {
        const result = await fetchPageBySlug(slug);
        if (result.success && result.data) {
          setPage(result.data);
        }
      }
      setLoading(false);
    };
    
    loadPage();
  }, [slug]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!page) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '16px' }}>Page Not Found</h1>
          <p style={{ marginBottom: '16px' }}>The page you're looking for doesn't exist or is not published.</p>
          <Link to="/" style={{ color: 'var(--blue)' }}>
            Go to Home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fff' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '24px' }}>
        <Link to="/" style={{ color: 'var(--blue)', marginBottom: '16px', display: 'inline-block' }}>
          ← Back to Home
        </Link>
        <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: '24px' }}>{page.title}</h1>
        <div 
          className="prose"
          style={{ maxWidth: 'none' }}
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </div>
    </div>
  );
};

export default StaticPageView;